import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "d-flex align-bottom my-6" }
const _hoisted_3 = { class: "mr-8" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { class: "mt-2 font-weight-bold" }
const _hoisted_6 = { style: {"font-size":"40px"} }
const _hoisted_7 = { class: "mr-8" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "mt-2 font-weight-bold" }
const _hoisted_10 = { style: {"font-size":"40px"} }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = { class: "text-left" }
const _hoisted_19 = {
  key: 0,
  style: {"color":"deeppink"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "d-flex align-center justify-center" }
const _hoisted_25 = { class: "d-flex align-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_date_pager = _resolveComponent("date-pager")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('features.nursery-web-attendance-list')), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.selectBtn,
        loading: _ctx.loading,
        "close-on-content-click": false,
        color: "primary",
        variant: "outlined",
        class: "mr-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')) + " ", 1),
          _createVNode(_component_v_row, { class: "selectDL" }, {
            default: _withCtx(() => [
              (_ctx.selectDownload)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _ctx.monthly,
                    modelValue: _ctx.monthlyDownload,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.monthlyDownload) = $event)),
                    color: "primary",
                    variant: "text",
                    class: "btnDL mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('attendance.monthlyAttendance')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.selectDownload)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    onClick: _ctx.daily,
                    modelValue: _ctx.dailyDownload,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dailyDownload) = $event)),
                    color: "primary",
                    variant: "text",
                    class: "btnDL mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('attendance.dailyAttendance')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.searchAttendance,
        loading: _ctx.loading,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("mdi-sync", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.update')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_date_pager, {
          modelValue: _ctx.searchFilters.date,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date) = $event)),
          class: "pt-4"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('attendance.currentChildCount')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.attendances ? (_ctx.attendances.summary.presentChildrenCount - _ctx.startCount) : 0), 1),
          _createTextVNode(" / " + _toDisplayString(_ctx.attendances ? _ctx.attendances.summary.totalChildrenCount : 0), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('attendance.absent')), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.attendances ? _ctx.attendances.summary.absentChildrenCount : 0), 1)
        ])
      ])
    ]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-4 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.class')), 1),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.classId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.classId) = $event)),
                      items: _ctx.classes,
                      "item-title": (item) => `(${item.year}) ${item.className}`,
                      "item-value": "classId",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      clearable: "",
                      disabled: _ctx.loading
                    }, null, 8, ["modelValue", "items", "item-title", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('attendance.attendanceStatus')), 1),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.status,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.status) = $event)),
                      items: _ctx.statusItems,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      disabled: _ctx.loading,
                      clearable: ""
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.gender')), 1),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.gender,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.gender) = $event)),
                      items: _ctx.genderItems,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      disabled: _ctx.loading,
                      clearable: ""
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.age')), 1),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.age,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.age) = $event)),
                      items: _ctx.ageItems,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      disabled: _ctx.loading,
                      clearable: ""
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.attendances)
      ? (_openBlock(), _createBlock(_component_v_table, {
          key: 0,
          class: "pt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('attendance.childName')), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('attendance.attendanceStatus')), 1),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('attendance.checkInTime')), 1),
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('attendance.checkOutTime')), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('attendance.feverPrediction')), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('attendance.className')), 1),
                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('common.gender')), 1),
                _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('common.age')), 1),
                _cache[13] || (_cache[13] = _createElementVNode("th", { class: "text-left" }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendances.attendances, (a) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: a.child.childId
                }, [
                  _createElementVNode("td", null, _toDisplayString(a.child.lastName) + " " + _toDisplayString(a.child.firstName), 1),
                  _createElementVNode("td", null, [
                    (a.status == 'isAbsent')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.getStatusText(a.status)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.getStatusText(a.status)), 1))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(a.attendedAt ? _ctx.formatDate(a.attendedAt) : "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(a.leftAt ? _ctx.formatDate(a.leftAt) : "-"), 1),
                  _createElementVNode("td", null, [
                    (a.isFeverAlert == 'FEVER')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_v_chip, {
                            small: "",
                            color: "error",
                            label: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.fever')), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : (a.isFeverAlert == 'MODEST_FEVER')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_v_chip, {
                              small: "",
                              color: "orange",
                              "text-color": "white",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('attendance.mildFever')), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, "-"))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getClassName(a.child)), 1),
                  _createElementVNode("td", null, [
                    (a.child.gender == 'male')
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "blue",
                          variant: "tonal",
                          dark: "",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.male')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          color: "pink lighten-2",
                          variant: "tonal",
                          dark: "",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.female')), 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('common.yearsOld', { n: _ctx.getAgeBasedonBirthdate(a.child.dateOfBirth) })), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "flat",
                      small: "",
                      to: `/attendance/${a.child.childId}/${a.date}/edit`,
                      disabled: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "disabled"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.monthlyDownload,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.monthlyDownload) = $event)),
      "close-on-content-click": false,
      "max-width": "645px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_v_card, { class: "DLMon" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "pb-6 download-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.downloadMonthly', { date: _ctx.DLDate })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.monthlyDownload = false)),
                    color: "grey",
                    style: {"color":"white"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.monthlyBtnDL,
                    color: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" OK ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dailyDownload,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dailyDownload) = $event)),
      "close-on-content-click": false,
      "max-width": "625px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_v_card, { class: "DLDay" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "pb-6 download-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.downloadDaily', { date: _ctx.DLDate })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dailyDownload = false)),
                    color: "grey",
                    style: {"color":"white"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.dailyBtnDL,
                    color: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode(" OK ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}